<app-loader *ngIf="isDisabled"></app-loader>
<div class="single-row-container">
    <div class="header-row">
        <div class="row w-100 gap-2">
            <div class="col align-content-center">
                <i class="bi bi-stopwatch"></i>
                <span class="fw-bold ps-2">Shift Group Master</span>
            </div>
            <div class="col-auto p-0">
                <button type="button" class="upload-btn" id="exportBtn" *ngIf="this.common.PageRight.IsPrint"
                    (click)="exportToExcel()" [disabled]="isDisabled">
                    <i class="bi bi-download" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Export':'Loading...'}}
                </button>
            </div>
            <!-- <div class="col-auto p-0">
                <button *ngIf="this.common.PageRight.IsAdd" type="button" (click)="upload()" class="upload-btn"
                    [disabled]="isDisabled">
                    <i class="bi bi-upload" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Upload':'Loading...'}}
                </button>
            </div> -->
            <div class="col-auto p-0">
                <button type="button" class="upload-btn" id="addBtn" (click)="add(0)" [disabled]="isDisabled"
                    *ngIf="this.common.PageRight.IsAdd">
                    <i class="bi bi-plus" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Add Shift Group':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
    <div class="m-3">
        <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
            class="customeDatatable table table-bordered">
            <thead class="table-light">
                <tr>
                    <th style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">Action</th>
                    <th>Shift Group Name</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let element of Shift">
                    <td style="width: 5px;">
                        <div class="text-center" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">
                            <button class="btn btn-sm btn-warning" type="button"
                                (click)="add(element['ESS_ShiftGroupMasterID'])"><i
                                    class="bi bi-pencil-square"></i></button>
                        </div>
                    </td>
                    <td> {{element['ShiftGroupName']}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>